import { createStore } from 'redux';
import thunk from 'redux-thunk';

import { applyMiddleware } from 'helpers/redux_dev_tools';
import rootReducer from './reducers';

export default function (state) {
  const store = createStore(rootReducer, state, applyMiddleware(thunk));

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(require('./reducers'));
    });
  }

  return store;
}
